
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {newInstrumentApi} from "@/api/instrument";
    import {dictApi} from "@/api/organization";
    import ckeditor4 from "@/components/CkeditorComponent.vue";
    import TableShowRangeHead from "@/components/table-show-range-head.vue";
    import TableShowRangeBody from "@/components/table-show-range-body.vue";
    import MeasuringRange from "@/components/MeasuringRange.vue";
    import SelectMechanism from "@/components/SelectMechanism.vue";
    import TableShowRangeBodyEjian from "@/components/table-show-range-body-ejian.vue";
    import MeasuringRangeEjian from "@/components/MeasuringRangeEjian.vue";
    const {CodeToText} =require("@/js/region/region");
    @Component({
        name: 'updateInstrument',
        components: {
          MeasuringRangeEjian,
          TableShowRangeBodyEjian,
          ckeditor4, TableShowRangeHead, TableShowRangeBody, MeasuringRange, SelectMechanism}
    })
    export default class Home extends Vue {
        @Prop()
        private instrId !: any; //器具ID
        visible = true;
        form = {
            name: '',
            typeCode: '',
            purposeCode: '',
            modelSpecific: '',
            serialNumber: '',
            manufactoryNameId: '',
            manufactoryId: '',
            manufactoryName: '',
            paramList: [],
        } as any
        typeCodeList = [];
        purposeCodeList = [];
        addSurveyRanges = {
            visible: false,
            surveyRanges: [],
            params: null as any,
        }
        keyword = "";//器具名称搜索
        rules = {
            serialNumber: [{ required: true, message: '请输入出厂编号', trigger: 'blur' }],
            modelSpecific: [{ required: true, message: '请输入规格型号', trigger: 'blur' }],
            measureRange: [{ required: true, message: '请填写测量范围 和 不确定度等级', trigger: 'blur' }],
        }
        props = {
            value: 'instrumentNameId',
            label: 'name',
        }
        created(){
            this.getDictAll();
            this.getInstrDetail();
        }
        @Watch('instrId')
        changeInstrId(){
            this.getInstrDetail();
        }
        getInstrDetail(){
            // instrumentApi.getById({id: this.instrId}).then((res: any) => {
          newInstrumentApi.getDetail(this.instrId).then((res: any) => {
              if(res.data.result === 0){
                    const rData = res.data.data;
                    //测量范围
                    // try {
                    //     const obj = JSON.parse(rData.measureRange);
                    //     if(typeof obj == 'object' && obj ){
                    //         rData.paramList = obj;
                    //     }
                    // } catch (e) {
                    //     console.log(e)
                    // }
                    Object.assign(this.form , rData);
                }
            });
        }
        submitAddSurveyRanges(e: any) {
            // let paramList = this.cloneObjectFn(e.paramList);
            // this.form.paramList = paramList;
            this.form = Object.assign({}, this.form, e);
            this.closeAddSurveyRangesDiglog();
        }

        openAddSurveyRangesDiglog(surveyRanges: any) {
          console.log(surveyRanges);
          this.addSurveyRanges.surveyRanges = surveyRanges;
            this.addSurveyRanges.params = {param1: 'measureRange', param2: 'accuracyLevel'};
            this.addSurveyRanges.visible = true;
        }
        closeAddSurveyRangesDiglog() {
            this.addSurveyRanges.visible = false;
            this.addSurveyRanges.surveyRanges = [];
            this.addSurveyRanges.params = null;
        }
        cloneObjectFn(obj: any) {
            return JSON.parse(JSON.stringify(obj));
        }
        //器具类型改变
        addTypesChange() {
            this.form.purposeCode = "";
        }
        getDictAll() {
            Promise.all([
                    dictApi.list({category: 1, code: ""}),
                    dictApi.list({category: 2, code: ""})
            ]).then((arr: any) => {
                const res1 = arr[0];
                const res2 = arr[1];
                if(res1.data.result === 0){
                    this.typeCodeList = res1.data.data;
                }
                if(res2.data.result === 0){
                    this.purposeCodeList = res2.data.data;
                }
            });
        }

        submitUpdateInstr() {
            let formEl = this.$refs.form as HTMLFormElement;
            formEl.validate((valid: any) => {
                if (valid) {
                    const form = this.form;
                    let params = {
                        ...this.form
                    }
                    //整理测量范围数据
                    // params.measureRange = JSON.stringify(params.paramList);
                    const purposeCodeObj = this.purposeCodeList.find((e: any) => e.code == this.form.purposeCode) as any;
                    if (purposeCodeObj) {
                        params.purposeName = purposeCodeObj.name;
                    }
                    //器具类型
                    const typeCodeObj = this.typeCodeList.find((e: any) => e.code == params.typeCode) as any;
                    if (typeCodeObj) {
                        params.typeName = typeCodeObj.name;
                    }
                    newInstrumentApi.updateInstrumentNotLogin(params).then((res: any) => {
                        if (res.data.result === 0) {
                            this.$emit("submitUpdateInstr", this.cloneObjectFn({
                                instrId: form.id,
                                instrName: form.name,
                                model: form.modelSpecific,
                                // paramList: form.paramList,
                                measureRange: form.measureRange,
                                accuracyLevel: form.accuracyLevel,
                                factoryNumber: form.serialNumber,
                                manufactoryName: this.form.manufactoryName,
                            }));
                        }
                    });
                }
            });
        }
        closeUpdateInstr() {
            this.$emit("closeUpdateInstr");
        }

        changeManufactory(e: any) {
            this.form.manufactoryId = e.mechanismId;
            this.form.manufactoryNameId = e.mechanismNameId;
            this.form.manufactoryName = e.mechanismName;
        }
    }
